import { colors, fonts } from '../theme';

const founders = [
  {
    initials: 'MS',
    name: 'Mallikarjun Sarvepalli',
    credential: 'Founder & CTO — 25+ years building digital products across AI, IoT, blockchain, and enterprise platforms.',
    linkedin: 'https://www.linkedin.com/in/malliksarvepalli/',
  },
  {
    initials: 'SS',
    name: 'Subodh Sankar',
    credential: 'Founder — entrepreneur with a track record of building startups from concept to delivery.',
    linkedin: 'https://www.linkedin.com/in/subodh-sankar-9aa405/',
  },
];

const Team = () => (
  <section id="team" style={{ padding: 'clamp(56px, 8vw, 96px) clamp(20px, 5vw, 48px)', background: colors.bgAlt }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ maxWidth: 700, marginBottom: 40 }}>
        <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 }}>Team</p>
        <p style={{ color: colors.slateDark, fontSize: 16.5, lineHeight: 1.7 }}>
          We are a team of engineers, entrepreneurs, and domain experts who've built products from zero to one before, and we're doing it again — reimagining how credibility is built in manufacturing, through continuous conformance instead of one-off assessments.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 24, marginBottom: 40 }}>
        {founders.map(f => (
          <div key={f.name} style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 14, padding: '26px 26px', display: 'flex', gap: 18 }}>
            <div style={{ width: 52, height: 52, borderRadius: '50%', flexShrink: 0, background: `linear-gradient(135deg,${colors.navy},${colors.teal})`, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: fonts.display, fontWeight: 600, fontSize: 17 }}>
              {f.initials}
            </div>
            <div>
              <h3 style={{ fontSize: 17, color: colors.navy, marginBottom: 8 }}>{f.name}</h3>
              <p style={{ fontSize: 14, color: colors.slate, lineHeight: 1.6, marginBottom: 10 }}>{f.credential}</p>
              <a href={f.linkedin} target="_blank" rel="noopener noreferrer" style={{ fontFamily: fonts.mono, fontSize: 12, color: colors.teal, fontWeight: 600, letterSpacing: '0.04em' }}>LinkedIn ↗</a>
            </div>
          </div>
        ))}
      </div>

      <div style={{ background: colors.navy, borderRadius: 14, padding: '28px 30px', color: '#fff' }}>
        <p style={{ fontSize: 16, lineHeight: 1.7, marginBottom: 14 }}>
          If you have deep expertise in this space, or are simply passionate about solving this problem, we'd love to hear from you.
        </p>
        <a href="mailto:mallikarjun.s@nthralabs.com" style={{ color: colors.teal, fontWeight: 700, fontSize: 15 }}>
          mallikarjun.s@nthralabs.com
        </a>
      </div>
    </div>
  </section>
);

export default Team;
